<template>
    <div class="contact">
        <div style="min-height: 5.6rem;"></div>
        <section class="banner" data-aos="fade-up" data-aos-duration="1000">
            <img  class="hidden-xs-only" src="/imgs/contact/lianxiwomen_erweima.jpg" alt="" />
            <img  class="hidden-sm-and-up" src="/imgs/contact/lianxiwomen_erweima.jpg" alt="" />
            <div data-aos="slide-down" data-aos-duration="1000">
                <h1>傲天医疗</h1>
                <p>
                    德才兼备，以德为本。重才，爱才，惜才，留才
                </p>
            </div>
        </section>

        <section class="me" data-aos="fade-up" data-aos-duration="1000">
            <div class="me-title">
                <div class="title">
                    <span></span>
                    <h3>加入我们</h3>
                </div>
            </div>
            <div class="me-content">
                <div class="me-content-left">
                    <div>
                        <p>关注傲天医疗</p>
                        <p>官方公众号</p>
                    </div>
                    <img  src="/imgs/contact/lianxiwomen_ditu.jpg" alt="" />
                    <p>了解最新新闻和行业动态</p>
                </div>
                <div class="me-content-right">
                    <p>联系我们</p>
                    <div class="me-content-right-desc">
                        <div>
                            <img 
                                src="/imgs/contact/lianxiwomen_youxiang.png"
                                alt=""
                            />
                            <p>
                                <span>联系邮箱</span>
                                <span>service@sinoatma.com</span>
                            </p>
                        </div>
                        <div>
                            <img 
                                src="/imgs/contact/lianxiwomen_dianhua.png"
                                alt=""
                            />
                            <p>
                                <span>联系电话:</span>
                                <span>+86 0755 2813 0111</span>
                            </p>
                        </div>
                        <div>
                            <img 
                                src="/imgs/contact/lianxiwomen_dizhi.png"
                                alt=""
                            />
                            <p>
                                <span style="white-space: pre"
                                    >地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址:</span
                                >
                                <span>深圳市龙华区龙华街道清湖社区</span>
                                <span>宝能科技园三期1栋A座一单元5层</span>
                            </p>
                        </div>
                    </div>
                    <!-- <div class="me-content-map">
                        <div id="map"></div>
                    </div> -->
                </div>
            </div>
        </section>

        <section class="job" data-aos="fade-up" data-aos-duration="1000">
            <div class="job-title">
                <div class="title">
                    <span></span>
                    <h3>在招职位</h3>
                </div>
            </div>
            <div class="job-content">
                <div class="job-content-list hidden-xs-only" :style="job.length<4?'justify-content:center;':''">
                    <div v-for="item of job" class="job-content-item" @click="handleJob(item)">
                        <span>{{item.jobName}}</span>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <div class="job-content-list hidden-sm-and-up" :style="job.length<2?'justify-content:center;':''">
                    <div v-for="item of job" class="job-content-item" @click="handleJob(item)">
                        <span>{{item.jobName}}</span>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { getCompanyRecruitments } from "@/utils/api.js";

export default {
    name: "Contact",
    components: {},
    data() {
        return {
            job:[]
        };
    },
    methods: {
        handleJob(e){
            window.open(e.jobRecruitmentUrl)
        },
        GETCompanyRecruitments(){
            getCompanyRecruitments().then(res=>{
                if(res.data.code == 10000){
                    const data = res.data.data
                    this.job = data 
                }
            })
        },
    },
    created() {
        document.title = "深圳市傲天医疗智能系统有限公司-加入我们"

    },
    mounted() {
        // this.map = new BMap.Map("map");
        // this.map.enableScrollWheelZoom();
        // var point = new BMap.Point(114.072272, 22.681113);
        // this.map.centerAndZoom(point, 20);
        // var marker = new BMap.Marker(point); // 创建标注
        // this.map.addOverlay(marker);

        this.GETCompanyRecruitments()
    },
};
</script>
<style lang="less" scoped>
.contact {
    .banner {
        width: 100vw;
        position: relative;
        min-height: 25.8rem;
        img {
            width: calc(100vw + 25px);
            min-height: 25.8rem;
            position: relative;
            z-index: 1;
            object-fit: cover;
        }
        > div {
            width: 100vw;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 2;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #fff;
            > h1 {
                font-size: 2.5rem;
                margin: 10vh 0 2rem;
            }
            > p {
                width: 450px;
                max-width: 80vw;
                text-align: center;
                font-size: 1.1rem;
                line-height: 1.6rem;
                margin: 0;
            }
        }
    }
    .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        > h3 {
            margin: 0;
            font-size: 2.6rem;
        }
        > span {
            display: block;
            width: 5.6rem;
            height: 0.4rem;
            background: #0f45f9;
            margin-bottom: 1rem;
        }
    }
    .me {
        max-width: 100vw;
        width: 67rem;
        margin: 20px auto;
        padding-top: 7.7rem;
        padding-bottom: 3rem;
        .me-title {
            margin-bottom: 3.3rem;
        }
        .me-content {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            .me-content-left {
                width: 400px;
                height: 480px;
                background: #fafafa;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                padding: 40px 0;
                font-size: 30px;
                text-align: center;
                margin-bottom: 20px;
                p {
                    margin: 0;
                }
            }
            .me-content-right {
                min-width: 400px;
                width: calc(100% - 420px);
                background: #fafafa;
                margin-bottom: 20px;
                > p {
                    margin: 0;
                    padding: 40px 40px 0;
                    // font-weight: bold;
                    font-size: 24px;
                }
                .me-content-right-desc {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    font-size: 16px;
                    color: #666666;
                    padding: 0 40px;
                    margin-top: 20px;
                    > div {
                        display: flex;
                        margin-bottom: 20px;
                        > img {
                            height: 18px;
                            margin-right: 0.5rem;
                        }
                        > p {
                            margin: 0;
                            display: flex;
                            flex-direction: column;
                        }
                    }
                }
                .me-content-map {
                    width: 100%;
                    height: 385px;
                    overflow: hidden;
                    #map {
                        width: 100%;
                        height: 120%;
                    }
                }
            }
        }
    }
    .job{
        padding-top: 7.7rem;
        padding-bottom: 7.7rem;
        background: #FAFAFA;
         .job-title {
            margin-bottom: 3.3rem;
        }
        .job-content{
            max-width: calc(100vw - 40px);
            width: 67rem;
            margin: 20px auto;
            .job-content-list{
                display: flex;
                flex-wrap: wrap;
            }
            .job-content-item{
                height: 5.55rem;
                width: 15.75rem;
                max-width: 41vw;
                background: #FFFFFF;
                margin: 0.5rem ;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-radius: 0.2rem;
                cursor: pointer;
                span{
                    margin-left: 1.66rem;
                    font-size: 1.44rem;
                }
                i{
                    margin-right: 1.66rem;
                    color: #0f45f9;
                    font-weight: bold;
                }
                &:hover{
                    background: #0f45f9;
                    color: #fff;
                    i{
                        color: #fff;
                    }
                }
            }
        }
    }
}
</style>
